import { effectivity_assignment } from "./index.js";
import { action } from "./index.js";
import { action_method } from "./index.js";
import { action_method_relationship } from "./index.js";
import { action_property } from "./index.js";
import { action_relationship } from "./index.js";
import { assembly_component_usage_substitute } from "./index.js";
import { class_ } from "./index.js";
import { class_system } from "./index.js";
import { configuration_design } from "./index.js";
import { configuration_item } from "./index.js";
import { configured_effectivity_assignment } from "./index.js";
import { document_file } from "./index.js";
import { draughting_model } from "./index.js";
import { drawing_revision } from "./index.js";
import { general_property } from "./index.js";
import { material_designation } from "./index.js";
import { mechanical_design_geometric_presentation_representation } from "./index.js";
import { presentation_area } from "./index.js";
import { product } from "./index.js";
import { product_concept } from "./index.js";
import { product_concept_feature } from "./index.js";
import { product_concept_feature_association } from "./index.js";
import { product_concept_feature_category } from "./index.js";
import { product_concept_feature_category_usage } from "./index.js";
import { product_definition } from "./index.js";
import { product_definition_formation } from "./index.js";
import { product_definition_formation_relationship } from "./index.js";
import { product_definition_relationship } from "./index.js";
import { product_definition_substitute } from "./index.js";
import { property_definition } from "./index.js";
import { requirement_for_action_resource } from "./index.js";
import { resource_property } from "./index.js";
import { security_classification } from "./index.js";
import { shape_aspect } from "./index.js";
import { shape_representation } from "./index.js";
import { stepExtractOptional, stepExtractArrayToken, stepExtractArrayBegin, skipValue, } from "../../step/parsing/step_deserialization_functions.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class applied_ineffectivity_assignment extends effectivity_assignment {
    get type() {
        return EntityTypesAP214.APPLIED_INEFFECTIVITY_ASSIGNMENT;
    }
    get items() {
        if (this.items_ === void 0) {
            let cursor = this.getOffsetCursor(1);
            const buffer = this.buffer;
            const endCursor = buffer.length;
            if (stepExtractOptional(buffer, cursor, endCursor) === null) {
                return [];
            }
            const value = [];
            let signedCursor0 = stepExtractArrayBegin(buffer, cursor, endCursor);
            cursor = Math.abs(signedCursor0);
            while (signedCursor0 >= 0) {
                const value1Untyped = this.extractBufferReference(buffer, cursor, endCursor);
                if (!(value1Untyped instanceof action) && !(value1Untyped instanceof action_method) && !(value1Untyped instanceof action_method_relationship) && !(value1Untyped instanceof action_property) && !(value1Untyped instanceof action_relationship) && !(value1Untyped instanceof assembly_component_usage_substitute) && !(value1Untyped instanceof class_) && !(value1Untyped instanceof class_system) && !(value1Untyped instanceof configuration_design) && !(value1Untyped instanceof configuration_item) && !(value1Untyped instanceof configured_effectivity_assignment) && !(value1Untyped instanceof document_file) && !(value1Untyped instanceof draughting_model) && !(value1Untyped instanceof drawing_revision) && !(value1Untyped instanceof general_property) && !(value1Untyped instanceof material_designation) && !(value1Untyped instanceof mechanical_design_geometric_presentation_representation) && !(value1Untyped instanceof presentation_area) && !(value1Untyped instanceof product) && !(value1Untyped instanceof product_concept) && !(value1Untyped instanceof product_concept_feature) && !(value1Untyped instanceof product_concept_feature_association) && !(value1Untyped instanceof product_concept_feature_category) && !(value1Untyped instanceof product_concept_feature_category_usage) && !(value1Untyped instanceof product_definition) && !(value1Untyped instanceof product_definition_formation) && !(value1Untyped instanceof product_definition_formation_relationship) && !(value1Untyped instanceof product_definition_relationship) && !(value1Untyped instanceof product_definition_substitute) && !(value1Untyped instanceof property_definition) && !(value1Untyped instanceof requirement_for_action_resource) && !(value1Untyped instanceof resource_property) && !(value1Untyped instanceof security_classification) && !(value1Untyped instanceof shape_aspect) && !(value1Untyped instanceof shape_representation)) {
                    throw new Error("Value in select must be populated");
                }
                const value1 = value1Untyped;
                if (value1 === void 0) {
                    throw new Error("Value in STEP was incorrectly typed");
                }
                cursor = skipValue(buffer, cursor, endCursor);
                value.push(value1);
                signedCursor0 = stepExtractArrayToken(buffer, cursor, endCursor);
                cursor = Math.abs(signedCursor0);
            }
            this.items_ = value;
        }
        return this.items_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
applied_ineffectivity_assignment.query = [EntityTypesAP214.APPLIED_INEFFECTIVITY_ASSIGNMENT];
applied_ineffectivity_assignment.expectedType = EntityTypesAP214.APPLIED_INEFFECTIVITY_ASSIGNMENT;
